﻿import './styles/angular.rangeSlider.css';

import './angular.rangeSlider.js';

export default 'ui-rangeSlider';